var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MBMWidget_Exchange_General blocked_region"},[_vm._v(" "+_vm._s(_vm.$t('blocked_by_region', {region:_vm.region}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }